<template>
  <div>
    <div class="row">
      <div class="col-sm-12">
        <div class="pull-right" style="margin: 10px 10px 5px;">
          <button
            class="btn edit-badge"
            style="margin-left: 5px;"
            @click.prevent="fieldsDisabled = !fieldsDisabled"
          >
            Editar
          </button>
          <button
            class="btn btn-primary"
            @click.prevent="updateGeneralInfos"
            :disabled="fieldsDisabled"
          >
            Salvar
          </button>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-2">
        <div class="form-group">
          <label for="">ID:</label>
          <div class="input-group">
            <input class="form-control" :disabled="true" v-model="empresaSelecionada.id" />
            <span class="input-group-btn">
              <button
                type="button"
                class="btn btn-default"
                v-btn-clipboard
                :data-clipboard-text="empresaSelecionada.id"
              >
                <i class="fa fa-clipboard"></i>
              </button>
            </span>
          </div>
        </div>
      </div>
      <div class="col-sm-2">
        <div class="form-group">
          <label for="">ID Folha:</label>
          <div class="input-group">
            <input
              class="form-control"
              :disabled="fieldsDisabled"
              v-model="empresaSelecionada.idSistemaFolha"
            />
            <span class="input-group-btn">
              <button
                type="button"
                class="btn btn-default"
                v-btn-clipboard
                :data-clipboard-text="empresaSelecionada.idSistemaFolha"
              >
                <i class="fa fa-clipboard"></i>
              </button>
            </span>
          </div>
        </div>
      </div>

      <div class="col-sm-6">
        <div class="form-group">
          <label for="">Nome Fantasia:</label>
          <div class="input-group">
            <input
              class="form-control"
              :disabled="fieldsDisabled"
              v-model="empresaSelecionada.fantasia"
            />
            <span class="input-group-btn">
              <button
                type="button"
                class="btn btn-default"
                v-btn-clipboard
                :data-clipboard-text="empresaSelecionada.fantasia"
              >
                <i class="fa fa-clipboard"></i>
              </button>
            </span>
          </div>
        </div>
      </div>

      <div class="col-sm-8">
        <div class="form-group">
          <label for="">Razão Social:</label>
          <div class="input-group">
            <input
              class="form-control"
              :disabled="fieldsDisabled"
              v-model="empresaSelecionada.razaoSocial"
            />
            <span class="input-group-btn">
              <button
                type="button"
                class="btn btn-default"
                v-btn-clipboard
                :data-clipboard-text="empresaSelecionada.razaoSocial"
              >
                <i class="fa fa-clipboard"></i>
              </button>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-4">
        <div class="form-group">
          <label for="">CNPJ:</label>
          <div class="input-group">
            <input
              class="form-control"
              :disabled="fieldsDisabled"
              v-model="empresaSelecionada.cnpj"
              @keypress="onlyNumbers"
            />
            <span class="input-group-btn">
              <button
                type="button"
                class="btn btn-default"
                v-btn-clipboard
                :data-clipboard-text="empresaSelecionada.cnpj"
              >
                <i class="fa fa-clipboard"></i>
              </button>
            </span>
          </div>
        </div>
      </div>
      <div class="col-sm-4">
        <div class="form-group">
          <label for="">IE:</label>
          <div class="input-group">
            <input
              class="form-control"
              :disabled="fieldsDisabled"
              v-model="empresaSelecionada.ie"
              @keypress="onlyNumbers"
            />
            <span class="input-group-btn">
              <button
                type="button"
                class="btn btn-default"
                v-btn-clipboard
                :data-clipboard-text="empresaSelecionada.ie"
              >
                <i class="fa fa-clipboard"></i>
              </button>
            </span>
          </div>
        </div>
      </div>
      <div class="col-sm-3">
        <div class="form-group">
          <label for="">IM:</label>
          <div class="input-group">
            <input
              class="form-control"
              :disabled="fieldsDisabled"
              v-model="empresaSelecionada.im"
            />
            <span class="input-group-btn">
              <button
                type="button"
                class="btn btn-default"
                v-btn-clipboard
                :data-clipboard-text="empresaSelecionada.im"
              >
                <i class="fa fa-clipboard"></i>
              </button>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-4">
        <div class="form-group">
          <label for="">
            Senha do Contribuinte

            <span
              title="Clique para ser redirecionado até a página de login (Sefaz)"
              style="cursor: pointer"
              @click.prevent="openSefazSite"
            >
              <a
                style="display: block."
                v-btn-clipboard
                :data-clipboard-text="empresaSelecionada.senhaContribuinte"
              >
                (SEFAZ)
              </a>
            </span>
          </label>
          <div class="input-group">
            <input
              class="form-control"
              :disabled="fieldsDisabled"
              v-model="empresaSelecionada.senhaContribuinte"
            />
            <span class="input-group-btn">
              <button
                type="button"
                class="btn btn-default"
                v-btn-clipboard
                :data-clipboard-text="empresaSelecionada.senhaContribuinte"
              >
                <i class="fa fa-clipboard"></i>
              </button>
            </span>
          </div>
        </div>
      </div>

      <div class="col-sm-7">
        <div class="input-group">
          <label for="">CNAE fiscal:</label>
          <multiselect
            id="multi-select-cnae"
            :disabled="fieldsDisabled"
            v-model="empresaSelecionada.cnae"
            :block-keys="['Tab']"
            :options="cnaes"
            :internal-search="false"
            @search-change="retrieveCnaes"
            :allow-empty="false"
            track-by="cnae"
            :customLabel="customLabel"
            placeholder="Selecione um CNAE"
            selectLabel="Selecionar"
            selectedLabel="Selecionado"
            deselect-label=""
          >
            <div slot="noResult">Nenhum resultado encontrado!</div>
            <div slot="option" slot-scope="props">
              {{ props.option.cnae }} - {{ props.option.descricao }}
            </div>
          </multiselect>
          <span class="input-group-btn">
            <button
              :disabled="fieldsDisabled"
              type="button"
              style="margin-top: 20px;"
              class="btn btn-primary"
              @click.prevent="retrieveCnaes(empresaSelecionada.cnae)"
            >
              <i class="fa fa-search"></i>
            </button>
          </span>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-12">
        <div class="col-sm-2">
          <label for="">Pacote contábil: </label>
          <toggle-button
            :disabled="fieldsDisabled"
            :value="empresaSelecionada.pacoteContabilidade"
            @change="
              empresaSelecionada.pacoteContabilidade = !empresaSelecionada.pacoteContabilidade
            "
            :width="50"
            :color="{ checked: '#00A65A', unchecked: '#DD4B39' }"
            :sync="true"
            :labels="{ checked: 'Sim', unchecked: 'Não' }"
          />
        </div>

        <div class="col-sm-2">
          <label for="">Emite NFCE: </label>
          <toggle-button
            :disabled="fieldsDisabled"
            :value="empresaSelecionada.nfce"
            @change="empresaSelecionada.nfce = !empresaSelecionada.nfce"
            :width="50"
            :color="{ checked: '#00A65A', unchecked: '#DD4B39' }"
            :sync="true"
            :labels="{ checked: 'Sim', unchecked: 'Não' }"
          />
        </div>

        <div class="col-sm-2">
          <label for="">NFSE: &nbsp; &nbsp; &nbsp; &nbsp;</label>
          <toggle-button
            :disabled="fieldsDisabled"
            :value="empresaSelecionada.nfse"
            @change="empresaSelecionada.nfse = !empresaSelecionada.nfse"
            :width="50"
            :color="{ checked: '#00A65A', unchecked: '#DD4B39' }"
            :sync="true"
            :labels="{ checked: 'Sim', unchecked: 'Não' }"
          />
        </div>

        <div class="col-sm-4">
          <div class="form-group">
            <label for="">Tipo Empresa:</label>
            <multiselect
              :disabled="fieldsDisabled"
              v-model="empresaTipoModel"
              :options="empresaTipos"
              :block-keys="['Tab']"
              :allow-empty="false"
              track-by="descricao"
              label="descricao"
              placeholder="Selecione um tipo"
              selectLabel="Selecionar"
              selectedLabel="Selecionado"
              deselect-label=""
              style="z-index: 2;"
            >
              <div slot="noResult">Nenhum resultado encontrado!</div>
            </multiselect>
          </div>
        </div>
      </div>
    </div>

    <hr />

    <div class="row">
      <div class="col-sm-5">
        <div class="form-group">
          <label for="">Regime Federal<span title=""></span></label>
          <div class="input-group">
            <span
              class="form-control"
              disabled
              v-btn-clipboard
              :data-clipboard-text="parsedRegimeFederal.regime"
              title="Regime Federal e Vigência"
            >
              {{ parsedRegimeFederal.regime + ' - ' + parsedRegimeFederal.vigencia }}
            </span>
            <span class="input-group-btn">
              <button type="button" class="btn btn-primary btn-sm" @click="modalRegime = true">
                <i class="fa fa-cog"></i>
                Alterar Regime
              </button>
            </span>
          </div>
        </div>
      </div>
      &nbsp;

      <div class="col-sm-6">
        <div class="form-group">
          <label for="">Crédito Outorgado<span title=""></span></label>
          <div class="input-group">
            <span
              class="form-control"
              disabled
              v-btn-clipboard
              :data-clipboard-text="outorgadoData.descricao"
              title="Crédito Outorgado"
            >
              {{ spanDescriptionOutorgado }}
            </span>
            <span class="input-group-btn">
              <button type="button" class="btn btn-primary btn-sm" @click="modalOutorgado = true">
                <i class="fa fa-cog"></i>
                Alterar Outorgado
              </button>
            </span>
          </div>
        </div>
      </div>
    </div>

    <modal v-if="modalRegime" @close="modalRegime = !modalRegime" classes="modal-mid-sm">
      <div slot="modal-title" class="text-center">
        Alterar Regime Federal
      </div>
      <div slot="modal-body">
        <modal-regime-federal @on-save="data => onSaveModalRegime(data)" />
      </div>
    </modal>

    <modal v-if="modalOutorgado" @close="modalOutorgado = !modalOutorgado" classes="modal-mid-sm">
      <div slot="modal-title" class="text-center">
        Alterar Crédito Outorgado
      </div>
      <div slot="modal-body">
        <modal-outorgado :outorgadoData="outorgadoData" />
      </div>
    </modal>

    <div class="row">
      <div class="col-sm-12" style="margin-bottom: 0;">
        <endereco-box @on-update-address="setCompanyInfo" />
      </div>
    </div>

    <div class="row">
      <div class="col-sm-12" style="margin-bottom: 0;">
        <empresa-contatos @on-update-contact="setCompanyInfo" />
      </div>
    </div>

    <div class="row">
      <div class="col-sm-12">
        <contabilista />
      </div>
    </div>

    <div class="row">
      <div class="col-sm-12">
        <empresa-certificado :empresa="value || empresaSelecionada" />
      </div>
    </div>

    <div class="row">
      <div class="col-sm-12">
        <empresa-rh component />
      </div>
    </div>
  </div>
</template>

<script>
import EmpresaCertificado from './EmpresaCertificado.vue'
import EmpresaContatos from './EmpresaContatos.vue'
import EmpresaRegimes from './EmpresaRegimes.vue'
import EmpresaRh from './EmpresaRH.vue'
import Modal from '../../components/Modal.vue'
import ModalRegimeFederal from './ModalRegimeFederal.vue'
import EmpresaService from '../../services/EmpresaService'
import EnderecoBox from './EnderecoBox.vue'
import Multiselect from 'vue-multiselect'
import InputCnpj from '../../components/Inputs/InputCnpj.vue'
import debounce from 'debounce'
import ModalOutorgado from './ModalOutorgado.vue'
import moment from 'moment'
import Contabilista from './Contabilista.vue'

export default {
  name: 'empresa-detalhes',
  props: {
    value: {
      type: Object
    }
  },
  data() {
    return {
      empresaSelecionada: this.$store.getters.getCompany,
      linkSefaz: `https://www.sefaz.mt.gov.br/acessoweb/login/LoginUsuarioContribuinte.jsp?tipoUsuario=6`,
      parsedRegimeFederal: {
        regime: '',
        vigencia: ''
      },
      modalRegime: false,
      regimeFederal: {},
      ie: '',
      senhaContribuinte: '',
      disablePasswordInput: false,
      disableIEInput: false,
      empresaTipos: [],
      empresaTipoModel: {
        descricao: '',
        id: 0
      },
      fieldsDisabled: true,
      pacoteContabilidade: true,
      nfce: true,
      nfse: true,
      cnaes: [],
      modalOutorgado: false,
      outorgadoData: {},
      spanDescriptionOutorgado: ''
    }
  },
  mounted() {
    this.empresaSelecionada = this.value ? this.value : this.empresaSelecionada
    this.getRegime()
    this.getCreditoOutorgado()
    this.retrieveEmpresaTipos().then(() => {
      const tipoModel = this.empresaTipos.find(
        tipo => this.normalize(tipo.descricao) === this.normalize(this.empresaSelecionada.tipo)
      )
      if (tipoModel) this.empresaTipoModel = tipoModel
    })
  },

  methods: {
    onlyNumbers(event) {
      const permitido = /^[0-9]$/
      if (!permitido.test(event.key)) {
        event.preventDefault()
      }
    },

    customLabel({ cnae, descricao }) {
      if (!cnae || !descricao) return ''
      return `${cnae} - ${descricao}`
    },

    retrieveCnaes: debounce(async function(cnae) {
      try {
        if (cnae) {
          const { data } = await EmpresaService.retrieveCnaeV2({ cnae })
          if (data.length === 1) {
            this.empresaSelecionada.cnae = data[0]
            document.querySelector('#multi-select-cnae').blur()
            return
          }
          this.cnaes = data
        }
      } catch (e) {
        this.$messages.error(e.message || e.data.message).toast('Não foi possível buscar os CNAES.')
        console.error(e)
      }
    }, 500),

    async updateGeneralInfos() {
      try {
        await EmpresaService.updateGeneralInfo(this.queryUpdate)
        this.$messages.success().toast('Informações atualizadas com sucesso !')
        this.setCompanyInfo()
      } catch (e) {
        this.$messages
          .error(e.message || e.data.message)
          .toast('Não foi possível atualizar as informações.')
        console.error(e)
      } finally {
        this.fieldsDisabled = true
      }
    },

    async retrieveEmpresaTipos() {
      try {
        let pesquisa = { limit: 1000, offset: 0 }
        const data = await EmpresaService.retrieveTipos(pesquisa)
        this.empresaTipos = data.body.data
      } catch (e) {
        this.$messages
          .error(e.message || e.data.message)
          .toast('Não foi possível buscar os tipos de empresa.')
        console.error(e)
      }
    },

    normalize(vl) {
      return vl.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    },

    async setCompanyInfo() {
      try {
        const { body } = await EmpresaService.pesquisaCompletaEmpresa({
          idEmpresa: this.empresaSelecionada.id
        })
        this.$store.dispatch('setCompany', body)
      } catch (e) {
        this.$messages
          .error(e.message || e.data.message)
          .toast('Não foi possível buscar as informações da empresa.')
        console.error(e)
      }
    },

    openSefazSite() {
      window.open(
        `${this.linkSefaz}&usuario=${this.empresaSelecionada.ie}`,
        '_blank',
        'location=yes,height=570,width=520,scrollbars=yes,status=yes'
      )
    },

    async onSaveModalRegime(data) {
      this.modalRegime = !this.modalRegime
      setTimeout(() => this.getRegime(), 400)
    },

    async getRegime() {
      try {
        const {
          data: [{ descricao, vigencia2 } = {}]
        } = await EmpresaService.getRegimeFederalByIdEmpresa({
          idEmpresa: this.empresaSelecionada.id
        })
        if (!descricao || !vigencia2) return (this.parsedRegimeFederal.regime = '')
        this.parsedRegimeFederal = { regime: descricao, vigencia: this.formatDate(vigencia2) }
      } catch (e) {
        this.$messages
          .error(e.message || e.data.message)
          .toast('Não foi possível buscar o regime da empresa.')
        console.error(e)
      }
    },

    formatDate(data) {
      return data
        ? data
          .split('T')[0]
          .split('-')
          .reverse()
          .join('/')
        : ''
    },

    async getCreditoOutorgado() {
      try {
        const { data } = await EmpresaService.searchCompanyOutorgado({
          idEmpresa: this.empresaSelecionada.id,
          vigencia: moment(new Date())
            .startOf('month')
            .format('YYYY-MM-DD')
        })
        if (!data[0].descricao || !data[0].vigencia) return
        this.outorgadoData = data[0]
        this.spanDescriptionOutorgado = `${this.outorgadoData.descricao} - ${this.formatDate(
          this.outorgadoData.vigencia
        )}`
      } catch (e) {
        this.$messages
          .error(e.message || e.data.message)
          .toast('Não foi possível verificar se a empresa possui crédito outorgado.')
        console.error(e)
      }
    }
  },
  components: {
    EmpresaRh,
    EmpresaRegimes,
    EmpresaCertificado,
    EmpresaContatos,
    Modal,
    ModalRegimeFederal,
    EnderecoBox,
    Multiselect,
    InputCnpj,
    ModalOutorgado,
    Contabilista
  },
  computed: {
    empresaCnae() {
      if (!this.empresaSelecionada.cnae) return {}
      return this.empresaSelecionada.cnae
    },
    queryUpdate() {
      return {
        idEmpresa: this.empresaSelecionada.id,
        idSistemaFolha: this.empresaSelecionada.idSistemaFolha,
        fantasia: this.empresaSelecionada.fantasia,
        razaoSocial: this.empresaSelecionada.razaoSocial,
        cnpj: this.empresaSelecionada.cnpj,
        ie: this.empresaSelecionada.ie,
        im: this.empresaSelecionada.im,
        senhaContribuinte: this.empresaSelecionada.senhaContribuinte,
        tipoEmpresa: this.empresaTipoModel.id,
        pacoteContabilidade: this.empresaSelecionada.pacoteContabilidade ? 1 : 0,
        nfce: this.empresaSelecionada.nfce,
        nfse: this.empresaSelecionada.nfse,
        cnae: this.empresaSelecionada.cnae.cnae
      }
    }
  }
}
</script>

<style lang="css" scoped>
.edit-badge {
  background-color: #52baf7;
  font-size: 13px;
  color: white;
  padding: 1px 4px;
  border-radius: 5px;
  margin: 5px 5px;
  cursor: pointer;
}
</style>
